import { PropTypes } from 'prop-types'
import React from 'react'

import useVideoContext from 'hooks/useVideoContext/useVideoContext'

import Student from './Student'
import Teacher from './Teacher'

const Tile = props => {
    const { isArtefactMode } = useVideoContext()

    return props?.identity?.isTeacher ? (
        <Teacher {...props} isArtefactMode={isArtefactMode} />
    ) : (
        <Student {...props} isArtefactMode={isArtefactMode} />
    )
}

Tile.propTypes = {
    identity: PropTypes.object,
    audioTrack: PropTypes.object,
    children: PropTypes.element,
    className: PropTypes.string,
    size: PropTypes.string,
    isVideoEnabled: PropTypes.bool,
    socket: PropTypes.object,
}

Tile.defaultProps = {
    identity: {},
    audioTrack: {},
    children: null,
    className: '',
    size: '',
    isVideoEnabled: false,
    socket: null,
}

export default Tile
